import React, { useState } from "react";
import QuoteApproval from "../../page-components-nozod/quote-approval/QuoteApproval";
import { createSearchParams, useLocation, useNavigate } from "react-router-dom";

const QuoteApprovalListForm = () => {
  const location = useLocation();
  const navigationData = location.state;

  const [isCoveringManager, setIsCoveringManager] = useState(
    navigationData && navigationData.isCoveringManager && navigationData.isCoveringManager === true ? true : false
  );
  const navigate = useNavigate();

  //On click Document Icon each row
  const handleRedirectionQuoteDetails = async (param) => {
    let _navigationData = param.recordResponse;

    navigate(
      {
        pathname: "/quoteDetails",
        search: createSearchParams({
          quoteid: param.id,
          coveringManager: isCoveringManager,
        }).toString(),
      },
      { state: _navigationData }
    );
  };
  return (
    <QuoteApproval
      pdfViewer={false}
      handleRedirectionQuoteDetails={handleRedirectionQuoteDetails}
      isCoveringManager={isCoveringManager}
      setIsCoveringManager={setIsCoveringManager}
    />
  );
};

export default QuoteApprovalListForm;
